import { Box, Button } from "@mui/material";
import { SubscriptionContext, SubscriptionTab } from "contexts/Subscription";
import { useContext } from "react";

import { trackEvent } from "utils/tracking";

import styles from "./styles";

const SubscriptionButton = () => {
  const { tab, setTab } = useContext(SubscriptionContext);

  const switchTab = (tabValue: SubscriptionTab) => {
    trackEvent("Subscription Plan Tab Changed", { Tab: tabValue });
    setTab(tabValue);
  };
  return (
    <Box sx={styles.container}>
      <Button
        onClick={() => switchTab(SubscriptionTab.monthly)}
        sx={[
          styles.button,
          tab === SubscriptionTab.monthly ? styles.active : styles.inactive,
        ]}
      >
        Pay Monthly
      </Button>
      <Button
        onClick={() => switchTab(SubscriptionTab.yearly)}
        sx={[
          styles.button,
          tab === SubscriptionTab.yearly ? styles.active : styles.inactive,
        ]}
      >
        <strong>Pay Yearly</strong>
        <Box sx={styles.yearlyText}>SAVE 25% + Free Template</Box>
      </Button>
    </Box>
  );
};

export default SubscriptionButton;
